export default "__VITE_ASSET__48ccd719__"